import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: []
};
export var DashboardReducer = createSlice({
    name: 'dashboard',
    initialState: initialState,
    reducers: {
        setDashboard: function setDashboard(state, action) {
            state.data = action.payload;
        }
    }
});
var setDashboard = DashboardReducer.actions.setDashboard;
export { setDashboard };
export default DashboardReducer.reducer;
